
import { Component, InjectReactive, ProvideReactive, Vue } from 'vue-property-decorator'

import BackSvg from '@/components/BackSvg.vue';
import LocationInfo from '@/components/LocationInfo.vue';
import Locations from '@/components/Locations.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    BackSvg,
    LocationInfo,
    Locations,
  }
})
export default class FavoriteLocations extends Vue {
  @ProvideReactive('viewContainerRef') viewContainerRef: Element | undefined;
  @InjectReactive() isMobile!: boolean;
  previewLocation: Restaurant | null;

  data() {
    return {
      previewLocation: null
    }
  }

  get isLoggedIn() {
    return UserModule.loggedIn;
  }

  get orderHistory() {
    return UserModule.orderHistory;
  }

  mounted() {
    this.viewContainerRef = this.$refs.container as Element;
  }

  async handleAddFavorite(location: Restaurant) {
    try {
      const favoriteModel = await UserModule.addFavoriteLocation({ restaurantId: location.id, isDefault: false }) as FavoriteLocationModel;
      if (favoriteModel) {
        const addedLocation: FavoriteRestaurant = {
          ...location,
          isDefault: favoriteModel.isDefault,
          favoriteId: favoriteModel.id
        };
        UserModule.addFavoriteLocationToCustomer(addedLocation);
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    }
  }

  async handleRemoveFavorite(location: Restaurant) {
    const favorite = UserModule.favoriteRestaurants.find((restaurant) => restaurant.id === location.id);
    if (favorite) {
      try {
        UserModule.removeFavoriteLocationFromCustomer(favorite);
        await UserModule.removeFavoriteLocation(favorite.id);
      } catch (err) {
        UserModule.addFavoriteLocationToCustomer(favorite);
        this.$log.error(err);
        this.$toasted.error(err.data);
      }
    }
  }
}
